// This shim provides compatibility between the deprecated leaflet-label and Leaflet 1.9+ bindTooltip
import L from 'leaflet';

// Make sure Leaflet is available globally
window.L = window.L || L || {};

/**
 * This shim replaces the deprecated leaflet-label library with Leaflet's native tooltip functionality.
 *
 * Migration from bindLabel to bindTooltip:
 *
 * Before:
 *   marker.bindLabel('Label text', {
 *     noHide: true,
 *     direction: 'right',
 *     className: 'my-label'
 *   });
 *
 * After:
 *   marker.bindTooltip('Label text', {
 *     permanent: true,
 *     direction: 'right',
 *     className: 'my-label'
 *   });
 *
 * Option mapping:
 * - noHide -> permanent
 * - direction -> direction (same options: 'right', 'left', 'top', 'bottom', 'center', 'auto')
 * - className -> className (same usage)
 * - offset -> offset (L.Point in both cases)
 * - opacity -> opacity (same usage)
 * - zoomAnimation -> no direct equivalent, tooltips are animated by default
 *
 * New options in bindTooltip:
 * - sticky: boolean - tooltip follows the mouse instead of being fixed at the feature center
 * - interactive: boolean - if true, tooltip will listen to mouse events
 * - pane: string - which pane to show the tooltip in
 */

// Add bindLabel method to L.Layer as a wrapper around bindTooltip
L.Layer.include({
    bindLabel: function (content, options) {
        'use strict';
        // Convert bindLabel options to bindTooltip options
        var tooltipOptions = options || {};

        // Map noHide to permanent
        if (options && options.noHide !== undefined) {
            tooltipOptions.permanent = options.noHide;
            delete tooltipOptions.noHide;
        }

        // Call bindTooltip with the converted options
        return this.bindTooltip(content, tooltipOptions);
    },

    unbindLabel: function () {
        'use strict';
        // Just call unbindTooltip
        return this.unbindTooltip();
    },

    showLabel: function () {
        'use strict';
        // Call openTooltip instead
        return this.openTooltip();
    },

    hideLabel: function () {
        'use strict';
        // Call closeTooltip instead
        return this.closeTooltip();
    },

    setLabelNoHide: function (noHide) {
        'use strict';
        // Update the permanent option on the tooltip
        if (this.getTooltip()) {
            this.getTooltip().options.permanent = noHide;
        }
        return this;
    }
});

// Re-export for consistency
export default 'leaflet-label-shim';
